// Shared slug + label maps for the public Jeedigunta site.

export const CATEGORY_LABELS = {
  galakala:              { te: "గళ కళ",            en: "Voice Art",          short: "గళ కళ" },
  kalam_galam:           { te: "కలం-గళం",          en: "Writer-Voice Art",   short: "కలం-గళం" },
  toli_kathanam:         { te: "తొలి కథనం",        en: "Debut Storytelling", short: "తొలి కథనం" },
  toli_kathanam_galam:   { te: "తొలి కథనం - గళం",  en: "Debut Voice Art",    short: "తొలి కథనం-గళం" },
  toli_kathanam_kalam:   { te: "తొలి కథనం - కలం",  en: "Debut Writer-Voice", short: "తొలి కథనం-కలం" },
};

// Map URL slug ↔ DB slug. URL uses dashes for readability; DB uses underscores.
export const URL_TO_DB_CATEGORY = {
  "galakala": "galakala",
  "kalam-galam": "kalam_galam",
  "toli-kathanam": "toli_kathanam",
  "toli-kathanam-galam": "toli_kathanam_galam",
  "toli-kathanam-kalam": "toli_kathanam_kalam",
};

export const DB_TO_URL_CATEGORY = Object.fromEntries(
  Object.entries(URL_TO_DB_CATEGORY).map(([url, db]) => [db, url])
);

export const RANK_LABELS = {
  1: { te: "ప్రథమ పురస్కారం", en: "1st Place" },
  2: { te: "ద్వితీయ పురస్కారం", en: "2nd Place" },
  3: { te: "తృతీయ పురస్కారం", en: "3rd Place" },
};

export const SPECIAL_JURY_LABEL = {
  te: "ప్రత్యేక నిర్ణేత గౌరవం",
  en: "Special Jury Recognition",
};

export const SEASON_EDITION_LABEL = {
  2024: { te: "ప్రారంభ సంచిక", en: "Inaugural Cycle" },
  2026: { te: "2వ వార్షిక చక్రం", en: "2nd Annual Cycle" },
};

// Categories shown for a given year, in display order.
export const CATEGORIES_FOR_YEAR = {
  "2024": ["galakala", "kalam_galam", "toli_kathanam"],
  "2026": ["galakala", "kalam_galam", "toli_kathanam_galam", "toli_kathanam_kalam"],
};

export const isWriterVoiceCategory = (cat) =>
  cat === "kalam_galam" || cat === "toli_kathanam_kalam";

// performances.category is stored as Telugu strings in the existing DB.
// Canonical form is the NO-SPACE hyphen ('తొలి కథనం-గళం'), enforced by
// performances_category_check since 2026-07-01 (db/data-cleanup-lla-and-dedup.sql).
// Rows written before that used 'తొలి కథనం - గళం' (spaced); always compare
// through normalizeCategory() so either form lands in the right bucket.
export const PERF_CAT_GALAKALA    = "గళకళ";
export const PERF_CAT_KALAM_GALAM = "కలం-గళం";
export const PERF_CAT_TOLI_GALAM  = "తొలి కథనం-గళం";
export const PERF_CAT_TOLI_KALAM  = "తొలి కథనం-కలం";

export const normalizeCategory = (raw) =>
  raw ? String(raw).replace(/\s*-\s*/g, "-").replace(/\s+/g, " ").trim() : raw;

// Use this map when filtering performances by the slug we receive in URLs.
export const SLUG_TO_PERFORMANCE_CATEGORY_TELUGU = {
  galakala:            PERF_CAT_GALAKALA,
  kalam_galam:         PERF_CAT_KALAM_GALAM,
  toli_kathanam_galam: PERF_CAT_TOLI_GALAM,
  toli_kathanam_kalam: PERF_CAT_TOLI_KALAM,
  // Pre-2026 (single Toli Kathanam category): no exact Telugu match exists
  // since 2024 data was pre-split. Caller should fall back to UNION of the
  // two new slug Telugu strings.
  toli_kathanam: [PERF_CAT_TOLI_GALAM, PERF_CAT_TOLI_KALAM, "తొలి కథనం"],
};

export const PERFORMANCE_CATEGORY_TELUGU_TO_SLUG = {
  [PERF_CAT_GALAKALA]:    "galakala",
  [PERF_CAT_KALAM_GALAM]: "kalam_galam",
  [PERF_CAT_TOLI_GALAM]:  "toli_kathanam_galam",
  [PERF_CAT_TOLI_KALAM]:  "toli_kathanam_kalam",
};

// performances.category (either spelling) → award slug, or null if unmapped.
export const performanceCategorySlug = (raw) =>
  PERFORMANCE_CATEGORY_TELUGU_TO_SLUG[normalizeCategory(raw)] || null;

export const VOICE_PERF_CATS   = new Set([PERF_CAT_GALAKALA, PERF_CAT_TOLI_GALAM]);
export const WRITING_PERF_CATS = new Set([PERF_CAT_KALAM_GALAM, PERF_CAT_TOLI_KALAM]);
export const isVoiceSlug = (slug) =>
  slug === "galakala" || slug === "toli_kathanam_galam";

export const extractYouTubeId = (url) => {
  if (!url) return null;
  const m = url.match(/(?:youtu\.be\/|v=|\/shorts\/|\/embed\/)([A-Za-z0-9_-]{11})/);
  return m ? m[1] : null;
};
